import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminRidesPage from './pages/AdminRidesPage';
import AdminDailyRidesPage from './pages/AdminDailyRidesPage';
import AdminRideDetailPage from './pages/AdminRideDetailPage';
import AdminReferralsPage from './pages/AdminReferralsPage';
import AdminDriverRatingsPage from './pages/AdminDriverRatingsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import SupportPage from './pages/SupportPage';
import './App.css';
import './Admin.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/referrals" element={<AdminReferralsPage />} />
        <Route path="/admin/ratings" element={<AdminDriverRatingsPage />} />
        <Route path="/admin/hire-rides" element={<AdminRidesPage />} />
        <Route path="/admin/instant-rides" element={<AdminDailyRidesPage />} />
        <Route path="/admin/rides" element={<Navigate to="/admin/hire-rides" replace />} />
        <Route path="/admin/daily-rides" element={<Navigate to="/admin/instant-rides" replace />} />
        <Route path="/admin/rides/:source/:id" element={<AdminRideDetailPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
